import * as React from "react";
import { format } from "date-fns";

interface DateTimeStampProps {
  date: number | string | Date;
  withYear?: boolean;
  lightWithYear?: boolean;
  light?: boolean;
  lightWithDay?: boolean;
  dateOnly?: boolean;
  shortDateOnly?: boolean;
}

const LIGHT = "MMMM d, yyyy";
const LIGHT_WITH_DAY = "EEEE MMMM d, yyyy";
const FORMAT = "dd MMM, HH:mm";
const YEAR_FORMAT = "dd MMM yyyy, HH:mm";
const LIGHT_YEAR_FORMAT = "dd MMM yyyy";
const DATE_ONLY_FORMAT = "MM/dd/yyyy";
const SHORT_DATE_ONLY_FORMAT = "MM/dd/yy";

export default function DateTimeStamp({
  date,
  withYear,
  lightWithDay,
  light,
  dateOnly,
  lightWithYear,
  shortDateOnly,
}: DateTimeStampProps) {
  const dateFormat = () => {
    if (lightWithDay) return LIGHT_WITH_DAY;
    if (light) return LIGHT;
    if (withYear) return YEAR_FORMAT;
    if (dateOnly) return DATE_ONLY_FORMAT;
    if (lightWithYear) return LIGHT_YEAR_FORMAT;
    if (shortDateOnly) return SHORT_DATE_ONLY_FORMAT;
    return FORMAT;
  };

  let val = "";
  try {
    if (date) {
      val = format(new Date(date), dateFormat());
    }
  } catch (ex) {
    console.error(ex);
  }

  return <span className={"fdt"}>{val}</span>;
}
